import React from 'react'
import Link from 'react-router/lib/Link'

const Closed  = () => {
  return (
    <div className="jumbotron">
      <h1>Enrolment is closed!</h1>
      <hr />
      <div className="row">
        <div className="col-sm-4 text-center">
          <Link to="/cor" className="btn btn-info btn-lg btn-block">View Certificate of Registration</Link>
        </div>
      </div>
    </div>
  )
}

export default Closed



// WEBPACK FOOTER //
// ./src/containers/Enrolment/closed.js